import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import DateTime from 'react-datetime';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

class FormaterDate extends Component {
  static propTypes = {
      value: PropTypes.string
    };
    constructor(props) {
      super(props);
      this.state = {
        startDate: moment
      }
      this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps) {
      return nextProps.value !== this.props.value;
    }

    handleChange = date => 
      this.setState({
        startDate: date
      });
    

    render() { 
      let curdate
      if (this.props.value !== null) {
      if (typeof(this.props.value) == 'string') {
       let value = this.props.value.split('-');
       curdate = new Date(this.props.value); 
      // curdate = new Date(value[0], value[1] - 1, value[2]); 
      }
      else
      {
        if (typeof(this.props.value) == 'object') {
          curdate = this.props.value._d
        }
        else
        {
          curdate = this.props.value
        }
      }

      let options = {year: 'numeric', month: 'numeric', day: 'numeric' };
        return <div style={{ textAlign: this.props.Align, color: this.props.Color }} title={`${curdate.toLocaleDateString('ru-RU'/*,options*/)} ${this.props.Time == true ? curdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }):''}`}>{`${curdate.toLocaleDateString('ru-RU'/*,options*/)} ${this.props.Time == true ? curdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }):''}`}</div>;
       //return <div title={value.format("L")}>{value.format("L")}</div>;
      /* return <div> <DatePicker
        selected={moment()}
        onChange={this.handleChange}
        dateFormat="LL"           
        /> </div>  */
       // return <DatePicker onChange={this.handleChange} value={curdate} />
        
      }
      else
      {
        let curdate = new Date() 
        let options = {year: 'numeric', month: 'numeric', day: 'numeric' };
        return null
       // return <div title={curdate.toLocaleDateString('ru-RU',options)}>{curdate.toLocaleDateString('ru-RU',options)}</div>;
      }
    }
  }

/*
  getColumns = () => {
  
      let eventDataGrid = {
        onClick: (ev, args) => {
          const idx = args.idx;
          const rowIdx = args.rowIdx;
          this.grid.openCellEditor(rowIdx, idx);
        }
      }
  
      return [
        {
          key: 'date',
          name: 'Date',
          width: 100,
          editable: true,
          editor:<DateEditor />,
          formatter: <DateFormater />,
          events:eventDataGrid
        }]
  }
  */
  export default FormaterDate;  